<template>
    <div>
        <div class="banner">
            <img :src="imageUrl + '/264628a3-7057-5cb2-96ff-ab94aaf4ad20.png'" />
            <div class="banner-content">
                <a href="https://sass.api.shoujimama.cn/rent/download" target="_blank" class="banner-btn">下载APP</a>
            </div>
        </div>
        <div class="page-nav">
            <div class="page-nav-box">
                <div class="page-nav-left">
                    您的位置：
                    <span class="el-icon-arrow-right"></span>
                    <span class="active">
                        {{moduleIndex==1?'租赁风控保障':'手机生态业务'}}
                    </span>
                </div>
                <div class="page-nav-right">
                    <div class="cursor-pointer" :class="moduleIndex==1?'active':''" @click="swtichModule(1)">租赁风控保障
                    </div>
                    <div class="cursor-pointer" :class="moduleIndex==2?'active':''" @click="swtichModule(2)">手机生态业务
                    </div>
                </div>
            </div>
        </div>
        <div class="module-1" v-if="moduleIndex == 1">
            <div class="device-control-box">
                <div class="device-control-title">
                    <div class="module-title">MDM设备监管</div>
                    <div class="module-subtitle">自研IOS、Android、Microsoft设备监管程序</div>
                </div>
                <div class="device-control-intro">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">
                                    <img src="../assets/productServices-ios-icon.png" />
                                </div>
                                <div class="name">IOS机型监管系统</div>
                                <div class="content">
                                    自研究IOS监管系统以来，针对套机、恶意逾期用户可实现风险预警、一键锁定功能。目前已建立了5万台设备的系统运行，安全性、稳定性、可靠性经过市场检验。
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">
                                    <img src="../assets/productServices-android-icon.png" />
                                </div>
                                <div class="name">安卓机型监管系统</div>
                                <div class="content">
                                    自研安卓监管系统，针对套机，恶意逾期，用户可实现风险提示，一键锁机功能。目前该系统已在2万台设备运行，安全性，稳定性，可靠性经过市场检验。
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 风控审核 -->
            <div class="risk-control-box">
                <div class="module-title">免押风控审核</div>
                <div class="module-subtitle">免押风控审核只指手机妈妈与多方合作，并结合自研数据分析系统从多维度对用户进行筛查分析</div>
                <div class="risk-control-list">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <div class="item">
                                <img class="icon" src="../assets/productServices-ailpay-icon.png" />
                                <div class="name">蚂蚁风控</div>
                                <div class="content">接入支付宝大数据进行分析，风控用户消费或其他金融行为</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="item">
                                <img class="icon" src="../assets/productServices-sjmm-icon.png" />
                                <div class="name">手机妈妈风控</div>
                                <div class="content">自研数据模型分析，多维度风控分析用户在司法，征信，其他消费或者金融行为</div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="item">
                                <img class="icon" src="../assets/productServices-user-icon.png" />
                                <div class="name">人工核实风控</div>
                                <div class="content">专业风控团队，行业多年风控经验，能根据客户解除，做出更精准判断</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 司法诉讼 -->
            <div class="proceeding-box">
                <div class="module-title">司法仲裁诉讼</div>
                <div class="module-subtitle">专业法务团队时尚跟踪</div>
                <div class="proceeding-intro">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">
                                    <img src="../assets/productServices-litigation-icon.png" />
                                </div>
                                <div class="name">法院诉讼</div>
                                <div class="content">
                                    在当事人和其他诉讼参与人的参加下，平等主体当事人之间发生经济纠纷提
                                    起诉讼，时间短，更高效的解决问题
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">
                                    <img src="../assets/productServices-proceeding-icon.png" />
                                </div>
                                <div class="name">仲裁委诉讼</div>
                                <div class="content">
                                    聘任社会上专业人士担任仲裁员,独立、公正、高效地解决平等主体的公民、
                                    法人和其他组织之间发生的合同纠纷和其他财产权益纠纷
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 区块链存证以及保险 -->
            <div class="blockchain-box">
                <div class="module-title">区块链存证以及保险</div>
                <div class="module-subtitle">客户下单时与平台的交互证据存入区块链，保证证据的合法性和安全性</div>
                <div class="blockchain-intro">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">STEP 1.</div>
                                <div class="name">合同存证</div>
                                <div class="content">
                                    客户在平台下单租赁订单时所签订的租赁协议，会把该协议存入区块链
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">STEP 2.</div>
                                <div class="name">回执存证</div>
                                <div class="content">
                                    客服在签收使用手机的时候会填写已使用签收和同意协议是回执单，同时也存入区块链
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">STEP 3.</div>
                                <div class="name">电子数据存证</div>
                                <div class="content">
                                    客户售前 售中 售后与平台工作人员的音频交互记录、文字交互记录、图文记录存入区块链
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="item">
                                <div class="icon">STEP 4.</div>
                                <div class="name">坏账保险</div>
                                <div class="content">
                                    本平台租赁订单可获得中国人保财产保险支持，最高可获赔90%
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="module-2" v-if="moduleIndex == 2">
            <!-- 回收置换 -->
            <div class="recovery-box">
                <div class="module-title">回收置换</div>
                <div class="module-subtitle">手机妈妈推出对客服的手机回收和新旧置换的服务</div>
                <div class="recovery-btns">
                    <div class="cursor-pointer" :class="recoveryIndex==1?'active':''" @click="swtichRecove(1)">关于回收
                    </div>
                    <div class="cursor-pointer" :class="recoveryIndex==2?'active':''" @click="swtichRecove(2)">回收置换
                    </div>
                </div>
                <div class="recovery-content">
                    <el-row>
                        <el-col :span="12">
                            <img class="recovery-content-img"
                                :src="imageUrl + '/19bf85ad-868a-445a-e852-973c82130103.png'" />
                        </el-col>
                        <el-col :span="12">
                            <div class="recovery-content-box" v-if="recoveryIndex == 1">
                                <div class="name">关于回收</div>
                                <div class="content">
                                    根据客服需求推出的手机回收服务，回收商可发布回收需求，或平台根据客户需求自动派单给予商户，业务功能可远程回收，同城回收
                                </div>
                                <a class="btn" href="https://sass.api.shoujimama.cn/rent/download"
                                    target="_blank">立即咨询</a>
                            </div>
                            <div class="recovery-content-box" v-if="recoveryIndex == 2">
                                <div class="name">置换回收</div>
                                <div class="content">
                                    根据客户需求推出的置换服务，入驻商可发布置换需求，或平台根据客户置换需求派单给予商户，客服也可在平台商户购买手机的时候置换相抵
                                </div>
                                <a class="btn" href="https://sass.api.shoujimama.cn/rent/download"
                                    target="_blank">立即咨询</a>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 维修检测 -->
            <div class="checkMaintaining-box">
                <div class="title-box">
                    <div class="module-title">维修检测</div>
                    <div class="module-subtitle">手机妈妈自营检测服务，有着行业30年手机检测技术与经验</div>
                </div>
                <div class="checkMaintaining-list">
                    <div class="item" v-for="(item, index) in checkMaintainingList" :key="index">
                        <div class="img">
                            <img :src="imageUrl + item.img" />
                        </div>
                        <div class="name">{{item.name}}</div>
                        <div class="content">{{item.content}}</div>
                    </div>
                </div>
            </div>
            <!-- 二手机调剂 -->
            <div class="secondPhong-box">
                <div class="module-title">二手机调剂</div>
                <div class="module-subtitle">为入驻商户提供二手机货源调度，从回收端到整合端再到出货端，系统化服务</div>
                <div class="secondPhong-intro">
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <div class="item">
                                <div class="icon">STEP 1.</div>
                                <div class="name">二手机租赁</div>
                                <div class="content">
                                    为入驻商户提供二手机租赁服务，从手机质检到用户筛查风控全方位保护
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="item">
                                <div class="icon">STEP 2.</div>
                                <div class="name">二手机调剂</div>
                                <div class="content">
                                    为入驻商户提供二手机货源调度，从回收端到整合端再到出货端，系统化服务
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="item">
                                <div class="icon">STEP 3.</div>
                                <div class="name">回收置换</div>
                                <div class="content">
                                    折抵换购或升级换购，回收价格高，快评估，专业质检免邮费
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 积分商城 -->
            <div class="integral-box">
                <div class="title-box">
                    <div class="module-title">积分商城</div>
                    <div class="module-subtitle">手机妈妈为其提供到店引流，营销促销等多种服务</div>
                </div>
                <div class="integral-list">
                    <div class="item">
                        <img src="http://img.zgwstxc.com/f20191a8-d651-9c1d-92b9-04e625a41d02.png" />
                        <div class="info">
                            <div class="name">红包积分</div>
                            <div class="content">
                                红包积分是手机妈妈红包商城里的一种积分它 是由客户租赁购买后产生的兑换积分，可以在 商城的兑换专区兑换自己想要的商品或者服务
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <img src="http://img.zgwstxc.com/a005e1db-f655-c1c4-c405-60914d2ca073.png" />
                        <div class="bg-color"></div>
                        <div class="info">
                            <div class="name">O2O商家</div>
                            <div class="content">
                                O2O商家是指和手机妈妈红包商城合作的商家或者供应商或者一些服务商，手机妈妈也为合作商家提供到店流量，营销促销服务
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-banner">
            <div class="title">以租代购，租享生活 ~</div>
            <a href="https://sass.api.shoujimama.cn/rent/download" target="_blank" class="btn">立即入驻</a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                moduleIndex: 1, //模版状态

                recoveryIndex: 1, //转换回收状态
                /* 检测检修 */
                checkMaintainingList: [{
                        name: '基础检测',
                        content: '只需在手机妈妈APP内利用该功能进行对手机的基本情况检测',
                        img: '/a8209e34-1ae6-9178-b20e-248d94c89f54.png'
                    },
                    {
                        name: '深度检测',
                        content: '有手机妈妈PC检测端进行深度检测可检测手机是被维修过，零件是否原装等100多项',
                        img: '/b87f8763-425f-37b8-bef8-1ae5ddb3cd29.png'
                    },
                    {
                        name: '人工检修',
                        content: '手机妈妈线下维修检测工厂进行人工检测或维修，30多年的技术与保障',
                        img: '/8e68a7bd-a852-349d-53ff-a8a0e93d169e.png'
                    }
                ],
                checkMaintainingImg: '/a8209e34-1ae6-9178-b20e-248d94c89f54.png', //检测检修配图
                checkMaintainingIndex: 0,

                integralMouseenterIndex: 1,
            };
        },
        created() {
            //console.log(document.getElementsByClassName('banner-img')[0].clientHeight);
        },
        methods: {
            //切换模块内容
            swtichModule(index) {
                this.moduleIndex = index;
            },
            //切换置换回收内容
            swtichRecove(index) {
                this.recoveryIndex = index;
            },
            //切换检测维修
            swtichCheckMaintaining(index) {
                this.checkMaintainingIndex = index;
                this.checkMaintainingImg = this.checkMaintainingList[index].img;
            },
            //积分商城鼠标经过
            integralMouseenter(index) {
                this.integralMouseenterIndex = index;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .page-nav {
        font-size: 22px;
        padding: 50px 30px;

        .page-nav-box {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .page-nav-left {
                color: #999999;
            }

            .page-nav-right {
                display: flex;
                flex-direction: row;

                .cursor-pointer {
                    color: #999999;
                    margin-left: 30px;
                }

                .cursor-pointer:first-child {
                    margin-left: 0px;
                }
            }

            .active {
                color: #1966FF !important;
                font-weight: bold;
            }
        }
    }

    .module-title {
        font-weight: 800;
        font-size: 34px;
    }

    .module-subtitle {
        margin-top: 24px;
        font-size: 20px;
    }

    .module-1 {
        .module-title {
            text-align: center;
        }

        .module-subtitle {
            text-align: center;
        }

        .device-control-box {
            background-color: #F7F8FA;
            padding: 50px 30px;

            .module-title {
                color: #121212;
            }

            .module-subtitle {
                color: #999999;
            }

            .device-control-intro {
                margin-top: 40px;

                .item {
                    background-color: #ffffff;
                    padding: 40px 30px;
                    border-radius: 10px;

                    img {
                        width: 38px;
                        height: 44px;
                    }

                    .name {
                        color: #1D2129;
                        font-size: 24px;
                        font-weight: 800;
                        margin-top: 40px;
                    }

                    .content {
                        line-height: 35px;
                        color: #4E5969;
                        font-size: 20px;
                        margin-top: 20px;
                    }
                }
            }
        }

        .risk-control-box {
            background-color: #E4F1FE;
            padding: 50px 30px;

            .module-title {
                color: #1966FF;
            }

            .module-subtitle {
                color: #4E5969;
            }

            .risk-control-list {
                margin-top: 40px;

                .item {
                    padding: 40px 30px;
                    background-color: #ffffff;
                    border-radius: 10px;

                    img {
                        width: 44px;
                        height: 44px;
                    }

                    .name {
                        color: #1D2129;
                        font-size: 24px;
                        margin-top: 25px;
                        font-weight: 800;
                    }

                    .content {
                        color: #4E5969;
                        font-size: 20px;
                        margin-top: 15px;
                        height: 170px;
                        line-height: 32px;
                    }
                }
            }
        }

        .proceeding-box {
            padding: 40px 30px;
            background-color: #282828;

            .module-title {
                color: #FFFFFF;
            }

            .module-subtitle {
                color: #999999;
            }

            .proceeding-intro {
                margin-top: 40px;

                .item {
                    border-radius: 20px;
                    background-color: #333333;
                    padding: 40px 30px;

                    img {
                        height: 44px;
                        width: 44px;
                    }

                    .name {
                        margin-top: 30px;
                        font-size: 20px;
                        font-weight: 800;
                        color: #FFFFFF;
                    }

                    .content {
                        color: #999999;
                        font-size: 20px;
                        margin-top: 20px;
                        height: 160px;
                        line-height: 35px;
                    }
                }
            }
        }

        .blockchain-box {
            font-size: 22px;
            padding: 40px 30px;
            background-color: #E4F1FE;

            .module-title {
                color: #121212;
            }

            .module-subtitle {
                color: #999999;
            }

            .blockchain-intro {
                margin-top: 20px;

                .item {
                    padding: 40px 30px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    margin-top: 20px;

                    .icon {
                        color: #1966FF;
                        font-weight: bold;
                        font-size: 24px;
                    }

                    .name {
                        font-weight: bold;
                        font-size: 24px;
                        color: #1D2129;
                        margin-top: 30px;
                    }

                    .content {
                        color: #4E5969;
                        font-size: 20px;
                        margin-top: 20px;
                        height: 100px;
                        line-height: 35px;
                    }
                }
            }
        }
    }

    .module-2 {
        .module-title {
            text-align: left;
        }

        .module-subtitle {
            text-align: left;
        }

        .recovery-box {
            background-color: #F7F8FA;
            padding: 40px 30px;

            .module-title {
                color: #121212;
            }

            .module-subtitle {
                color: #999999;
            }

            .recovery-btns {
                display: flex;
                flex-direction: row;
                margin-top: 60px;

                div {
                    border-radius: 4px;
                    padding: 0px 24px;
                    height: 46px;
                    line-height: 46px;
                    background-color: #ffffff;
                    margin-left: 20px;
                    font-size: 22px;
                }

                div:first-child {
                    margin-left: 0px;
                }

                .active {
                    background-color: #E0E8F8;
                    color: #1966FF;
                }
            }

            .recovery-content {
                margin-top: 50px;
                font-size: 0;
                border-radius: 10px;
                overflow: hidden;

                .recovery-content-img {
                    width: 100%;
                    height: 340px;
                    background-color: #F6F0FA;
                }

                .recovery-content-box {
                    background-color: #ffffff;
                    padding: 35px 30px 30px;
                    height: 275px;

                    .name {
                        font-size: 28px;
                        color: #121212;
                        font-weight: 800;
                    }

                    .content {
                        font-size: 20px;
                        margin-top: 30px;
                        color: #999999;
                    }

                    .btn {
                        margin-top: 25px;
                        display: inline-block;
                        background-color: #1966FF;
                        color: #ffffff;
                        width: 110px;
                        text-align: center;
                        height: 42px;
                        line-height: 42px;
                        border-radius: 4px;
                        font-size: 20px;
                    }
                }
            }
        }

        .checkMaintaining-box {
            padding: 50px 0px;
            font-size: 22px;
            background-color: #282828;

            .title-box {
                padding: 0px 30px;
            }

            .module-title {
                color: #ffffff;
            }

            .module-subtitle {
                color: #999999;
            }

            .checkMaintaining-list {
                margin-top: 40px;
                display: flex;
                flex-direction: row;
                overflow-x: scroll;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;

                .item {
                    margin-left: 30px;

                    .img {
                        background-color: #333333;
                        border-radius: 10px;
                        width: 520px;
                        padding: 20px;
                        font-size: 0px;

                        img {
                            width: 100%;
                            height: 376px;
                        }
                    }

                    .name {
                        margin-top: 30px;
                        font-size: 28px;
                        color: #ffffff;
                        font-weight: bold;
                    }

                    .content {
                        margin-top: 16px;
                        font-size: 20px;
                        color: #ffffff;
                        line-height: 35px;
                    }
                }
            }
        }

        .secondPhong-box {
            font-size: 22px;
            padding: 40px 30px;
            background-color: #F7F8FA;

            .module-title {
                color: #121212;
            }

            .module-subtitle {
                color: #999999;
            }

            .secondPhong-intro {
                margin-top: 20px;

                .item {
                    padding: 40px 30px;
                    background-color: #ffffff;
                    border-radius: 10px;
                    margin-top: 20px;

                    .icon {
                        color: #1966FF;
                        font-weight: bold;
                        font-size: 24px;
                    }

                    .name {
                        font-weight: bold;
                        font-size: 24px;
                        color: #1D2129;
                        margin-top: 30px;
                    }

                    .content {
                        color: #4E5969;
                        font-size: 20px;
                        margin-top: 30px;
                        height: 150px;
                        line-height: 35px;
                    }
                }
            }
        }

        .integral-box {
            padding: 50px 0px 50px 0px;
            font-size: 22px;
            background-color: #FFFFFF;

            .title-box {
                padding: 0px 30px;
            }

            .module-title {
                color: #121212;
            }

            .module-subtitle {
                color: #999999;
            }

            .integral-list {
                margin-top: 40px;
                display: flex;
                flex-direction: row;
                overflow-x: scroll;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;
                padding-right: 30px;

                .item {
                    position: relative;
                    margin-left: 30px;
                    border-radius: 10px;
                    font-size: 0;

                    img {
                        height: 290px;
                        width: 440px;
                    }

                    .bg-color {
                        position: absolute;
                        left: 0px;
                        bottom: 0px;
                        width: 100%;
                        border-radius: 10px;
                        height: 193px;
                        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
                    }

                    .info {
                        position: absolute;
                        bottom: 29px;
                        left: 0px;
                        color: #FFFFFF;
                        padding: 0px 20px;

                        .name {
                            font-size: 24px;
                            font-weight: bold;
                        }

                        .content {
                            font-size: 20px;
                            margin-top: 16px;
                        }
                    }
                }
            }
        }
    }

    ::-webkit-scrollbar {
        width: 0px;
    }

    ::-webkit-scrollbar-track {
        background-color: none;
    }

    ::-webkit-scrollbar-thumb {
        background-color: none;
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: none;
    }

    ::-webkit-scrollbar-thumb:active {
        background-color: none;
    }
</style>